import serviceApariencia from '@/services/GsEncuesta/apariencia'

export default {
  APARIENCIA_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceApariencia.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  APARIENCIA_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceApariencia.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  APARIENCIA_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceApariencia.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  APARIENCIA_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      serviceApariencia.delete(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
